module.exports = __webpack_public_path__ + "static/media/logo-usfq.c772baac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/partnership/logo-usfq.jpg
// module id = 149
// module chunks = 0